import axios from '@/api/client';

const state = {
  calenderEntries: null,
  calenderEntry: null,
  dueReminders: [],
  remindersLoading: false,
  remindersError: null,
};

const getters = {
  stateCalenderEntries: state => state.calenderEntries,
  stateCalenderEntry: state => state.calenderEntry,
  stateDueReminders: state => state.dueReminders,
  stateRemindersLoading: state => state.remindersLoading,
  stateRemindersError: state => state.remindersError,
};

const actions = {
  async getCalenderEntries({ commit }) {
    const { data } = await axios.get('calender');
    commit('setCalenderEntries', data);
    return data;
  },
  async viewCalenderEntry({ commit }, id) {
    const { data } = await axios.get(`calender/${id}`);
    commit('setCalenderEntry', data);
    return data;
  },
  async createCalenderEntry({ dispatch }, entry) {
    const { data } = await axios.post('calender', entry);
    await dispatch('getCalenderEntries');
    return data;
  },
  async updateCalenderEntry({ dispatch }, payload) {
    const { id, form } = payload || {};
    const { data } = await axios.patch(`calender/${id}`, form || {});
    await dispatch('getCalenderEntries');
    return data;
  },
  async deleteCalenderEntry({ dispatch }, id) {
    const { data } = await axios.delete(`calender/${id}`);
    await dispatch('getCalenderEntries');
    return data;
  },
  async getDueCalenderReminders({ commit }) {
    commit('setRemindersLoading', true);
    commit('setRemindersError', null);
    try {
      const { data } = await axios.get('calender/reminders/due');
      commit('setDueReminders', Array.isArray(data) ? data : []);
      return data;
    } catch (e) {
      commit('setRemindersError', e);
      throw e;
    } finally {
      commit('setRemindersLoading', false);
    }
  },
  async dismissCalenderReminder({ dispatch }, id) {
    const { data } = await axios.patch(`calender/${id}/reminder/dismiss`);
    await dispatch('getDueCalenderReminders');
    return data;
  },
  async snoozeCalenderReminder({ commit }, payload) {
    const { id, minutes } = payload || {};
    const { data } = await axios.patch(`calender/${id}/reminder/snooze`, {
      minutes: Number(minutes || 0),
      snooze_minutes: Number(minutes || 0),
    });
    commit('removeDueReminder', id);
    return data;
  },
  clearDueCalenderReminders({ commit }) {
    commit('setDueReminders', []);
    commit('setRemindersError', null);
  },
};

const mutations = {
  setCalenderEntries(state, entries) {
    state.calenderEntries = entries;
  },
  setCalenderEntry(state, entry) {
    state.calenderEntry = entry;
  },
  setDueReminders(state, reminders) {
    state.dueReminders = reminders;
  },
  removeDueReminder(state, id) {
    state.dueReminders = (Array.isArray(state.dueReminders) ? state.dueReminders : [])
      .filter((reminder) => {
        const reminderId = reminder?.idcalender_entry ?? reminder?.id ?? reminder?.calender_entry_id;
        return String(reminderId) !== String(id);
      });
  },
  setRemindersLoading(state, value) {
    state.remindersLoading = Boolean(value);
  },
  setRemindersError(state, error) {
    state.remindersError = error || null;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
